/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'

export interface SmallBoxModalProps {
  text: string
  titleKey: string
  onClose: () => void
}

export const SmallBoxModal: React.FC<SmallBoxModalProps> = ({ text, titleKey, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={true} handleClose={onClose} size="md" title={t(titleKey)}>
      <Modal.Body>
        <p>{text}</p>
      </Modal.Body>
    </Modal>
  )
}

export default SmallBoxModal
